import axios from "axios";
import utils from "./utils";
import managedata from "./managedata";

function _isAreaSaved(){
    let isAreaList = utils.isSessionValid('area-list')
    if(isAreaList) return isAreaList
    else return false
}

async function getAllArea(handleFailAreaList){
    let isValid = _isAreaSaved()
    if (!isValid) {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            data:{},
            type: { act: 'areasList' }
        };
        return await managedata.sendData(data, handleFailAreaList, 'sendBack')
            .then((response) => {
                utils.saveSession('area-list',JSON.stringify(response.data))
                return response.data
            })
            .catch((error) => {
                console.error(error);
                handleFailAreaList();
            });
    }else return  isValid
}

async function editArea(ID,subID,name){
    try {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            data:{
                ID,
                name,
                subToID: subID
            },
            type: { act: 'editArea' }
        };
        return await managedata.sendData(data,false,'sendBack')
    } catch (error) {
        console.error('Failed to fetch data:', error);
    }
}

async function addArea(name,subId){
    try {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            data:{
                name,
                subToID: subId
            },
            type: { act: 'addArea' }
        };
        return await managedata.sendData(data,false,'sendBack')
    } catch (error) {
        console.error('Failed to fetch data:', error);
    }
}

async function delArea(ID){
    try {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            data:{
                ID
            },
            type: { act: 'delArea' }
        };
        console.log('TEST',data)
        return await managedata.sendData(data,false,'sendBack')
    } catch (error) {
        console.error('Failed to fetch data:', error);
    }
}

export default {
    getAllArea,
    editArea,
    addArea,
    delArea
}